export const endpoints = {
    VUE_APP_TRANSACTIONS_API_BASE_URL: '/ast/transactions',
    VUE_APP_TRANSACTIONS_V2_API_BASE_URL: '/v2/transactions',
    VUE_APP_TRANSACTION_COUNTS_API_BASE_URL: '/v2/cachetxscounts',
    VUE_APP_ASSETS_V2_API_BASE_URL: '/v2/assets',
    VUE_APP_ADDRESSES_V2_API_BASE_URL: '/v2/addresses',
    VUE_APP_ADDRESS_CHAINS_V2_API_BASE_URL: '/v2/addressChains',
    VUE_APP_ADDRESS_COUNTS_V2_API_BASE_URL: '/v2/cacheaddresscounts',
    VUE_APP_AGGREGATES_V2_API_BASE_URL: '/v2/cacheaggregates',
    VUE_APP_ASSET_AGGREGATES_V2_API_BASE_URL: '/v2/cacheassetaggregates',
    VUE_APP_CACHE_ASSETS_V2_API_BASE_URL: '/v2/cacheassets',
    VUE_APP_EVM_TRANSACTIONS_V2_API_BASE_URL: '/v2/ctransactions',
    VUE_APP_EVM_BLOCKS_V2_API_BASE_URL: '/v2/ctxdata',
    VUE_APP_PRICE_API_URL: '/price'
}
